export default function TargetIcon(){
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6665 7.33398V4.58398L17.4165 1.83398L18.3332 3.66732L20.1665 4.58398L17.4165 7.33398H14.6665ZM14.6665 7.33398L10.9999 11.0006M20.1666 11.0007C20.1666 16.0633 16.0625 20.1673 10.9999 20.1673C5.93731 20.1673 1.83325 16.0633 1.83325 11.0007C1.83325 5.93804 5.93731 1.83398 10.9999 1.83398M15.5833 11.0007C15.5833 13.532 13.5312 15.584 10.9999 15.584C8.46861 15.584 6.41659 13.532 6.41659 11.0007C6.41659 8.46935 8.46861 6.41732 10.9999 6.41732"
        stroke="#656565"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}